
import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import type { TriggerClickFilterParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';
import type { PriceFilterValue } from '~~/types/integrations/tagManager/TagClickFilterTypes';

interface FilterClickParameters {
  filterInteraction: string,
  filterSection: string,
  filterName: string,
  filterValue: PriceFilterValue
}

export default function () {

  const { trackClickFilter } = useGtmEvents();
  const { getCurrentPageType } = usePageEventLocation();
  const {
    getters: {
      currentCategoryName,
    },
  } = useCategories();
  const route = useRoute();

  const getClickFilterEventData = (eventParameters: FilterClickParameters) => {

    const pageType = getCurrentPageType();
    const categoryName = pageType === EVENT_SOURCE.CATEGORY_LISTING ? currentCategoryName.value || '' : '';
    const categoryPath = pageType === EVENT_SOURCE.CATEGORY_LISTING ? route.params.slug || '' : '';

    const clickFilterEventData: TriggerClickFilterParameters = {
      filterInteraction: eventParameters.filterInteraction,
      filterSection: eventParameters.filterSection,
      filterName: eventParameters.filterName,
      filterValue: eventParameters.filterValue,
      categoryPath,
      categoryName,
      listingType: pageType,
    };

    return clickFilterEventData;
  
  };

  const callClickFilterEvent = (eventParameters: FilterClickParameters) => {

    const clickFilterEventData = getClickFilterEventData(eventParameters);
    trackClickFilter(clickFilterEventData);
  
  };

  return { callClickFilterEvent };

}
